// Helpers del grid de conciliación — lógica PURA, sin React.
import type {
    ReconciliationCell,
    ReconciliationStatus,
} from '@/api/services/retail-wizard/backoffice';

/** Clave de una celda del grid. El grid se indexa por día+tienda, no por posición. */
export function cellKey(date: string, storeId: string): string {
    return `${date}|${storeId}`;
}

/**
 * Índice de las celdas para buscarlas en O(1) al pintar.
 *
 * El silo manda las celdas planas y el grid las necesita por coordenada: recorrer el arreglo por
 * cada intersección sería 7 tiendas × 7 días = 49 barridos de la lista completa.
 */
export function cellsByKey(cells: ReconciliationCell[]): Map<string, ReconciliationCell> {
    return new Map(cells.map((c) => [cellKey(c.date, c.storeId), c]));
}

const DAY_NAMES = ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'];

/** `lun 28` — encabezado corto de la columna del día. */
export function dayLabel(date: string): string {
    const d = new Date(`${date}T12:00:00Z`);
    return `${DAY_NAMES[d.getUTCDay()]} ${String(d.getUTCDate())}`;
}

export function statusLabel(status: ReconciliationStatus): string {
    switch (status) {
        case 'MATCHED':
            return 'Cuadra';
        case 'MISMATCH':
            return 'Con diferencia';
        case 'PENDING_DEPOSIT':
            return 'Falta depositar';
        case 'NO_ACTIVITY':
            return 'Sin movimiento';
    }
}

/** Total de diferencias del rango, en centavos. Es el número que resume la pantalla. */
export function totalDifferenceCents(cells: ReconciliationCell[]): number {
    return cells.reduce((sum, c) => sum + c.differenceCents, 0);
}
